module.exports = __webpack_public_path__ + "static/img/40019 (4).9158e16.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40019 (4).webp
// module id = ZiVX
// module chunks = 14